export enum TaskType {
    ControlExecution = 1,
    // etc.
}
